<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
// import {umengInitWay} from './utils/umengSet'
export default {
  // beforeCreate() {
  //   umengInitWay()
  // }
}
</script>
<style>
/* @import "./theme/index.css"; */
  @import "./assets/global.css";
  @import "./assets/resetElement.css";
  
  #app {
    font-family: Helvetica, 'PingFang SC', "Helvetica Neue", "microsoft yahei", arial, STHeiTi, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 18px;
    color: #333;
  }
    /* 去掉页面滚动条 */
::-webkit-scrollbar {
  width: 0 !important;
}
::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}
</style>
